import { usePlayer } from "./player.jsx";
import { Users, Calendar, MapPin, BookOpen, Tag, Clock, ExternalLink } from 'lucide-react';

/** @import {Sermon} from './data.js' */

/**
 * Displays a single sermon in a series.
 *
 * @param {Object} props
 * @param {Sermon} props.sermon
 * @param {boolean} props.highlighted
 * @param {number} props.number
 * @param {string} props.imageUrl - Series image
 * @returns 
 */
export default function Sermon({ sermon, highlighted, number, imageUrl }) {
	const { setSermon } = usePlayer()
	const { title, speaker, scripture, permalink, duration, date, location = false, topics } = sermon;

	function addUtmSource(permalink) {
		try {
			// Create a URL object from the permalink
			const url = new URL(permalink);

			// Add or update the utm_source parameter
			url.searchParams.set('utm_source', 'redeemer.com');

			// Return the updated URL string
			return url.toString();
		} catch (error) {
			console.error('Invalid URL:', permalink);
			return permalink; // Return the original permalink in case of an error
		}
	}

	return (
		<li className={`series--sermon${highlighted ? ' is-highlighted' : ''}`}>
			<span className="series--sermon--number">{number}</span>
			<div className="series--sermon--mid-col">
				<span className="series--sermon--title">{title}</span>
				<div className="series--sermon--meta">
					{
						!!speaker.length &&
						<span><Users /> {speaker.join(', ')}</span>
					}
					{
						!!date &&
						<span><Calendar /> {date}</span>
					}
					{
						!!location &&
						<span><MapPin /> {location}</span>
					}
					{
						!!scripture.length &&
						<span><BookOpen /> {scripture.join(', ')}</span>
					}
					{
						!!duration &&
						<span><Clock /> {duration}</span>
					}
					{
						!!topics &&
						<span><Tag /> {topics.join(', ')}</span>
					}
				</div>
			</div>
			{
				!!permalink ?
				<a href={addUtmSource(permalink)} target="_blank" className="series--sermon--link gil-button is-small">
					View
					<ExternalLink color="currentColor" size={18} />
				</a> :
				<button onClick={() => setSermon({ ...sermon, imageUrl })} className="series--sermon--link gil-button is-small">
					View
				</button>
			}
		</li>
	)
}
